import { show, hide } from 'core/ui-utils'

interface IPopupOptions {
  closeOnOverlayClick?: boolean
}

type CloseCallback = (isOk: boolean) => void

const DEFAULT_OPTIONS: IPopupOptions = {
  closeOnOverlayClick: true
}

export class Popup {
  private el: HTMLElement
  private options: IPopupOptions
  private ui: {
    close: Element | null
    ok: Element | null
    cancel: Element | null
  }
  private closeCallbacks: CloseCallback[]

  constructor(el: HTMLElement, options: IPopupOptions = DEFAULT_OPTIONS) {
    this.el = el
    this.options = options
    this.ui = {
      close: this.el.querySelector('.js-close'),
      ok: this.el.querySelector('.js-ok'),
      cancel: this.el.querySelector('.js-cancel')
    }

    this.closeCallbacks = []

    hide(this.el)

    this.addEventListeners()
  }

  public close(isOk: boolean): void {
    this.hide()
    this.closeCallbacks.forEach(cb => cb(isOk))
  }

  public show(): void {
    show(this.el)
  }

  public hide(): void {
    hide(this.el)
  }

  public onClose(callback: CloseCallback): void {
    this.closeCallbacks.push(callback)
  }

  private addEventListeners(): void {
    if (this.ui.close) {
      this.ui.close.addEventListener('click', () => this.close(false))
    }

    if (this.ui.ok) {
      this.ui.ok.addEventListener('click', () => this.close(true))
    }

    if (this.ui.cancel) {
      this.ui.cancel.addEventListener('click', () => this.close(false))
    }

    if (this.options.closeOnOverlayClick) {
      this.el.addEventListener('click', e => {
        if ((e.target as Element).classList.contains('wz-popup-overlay')) {
          this.close(false)
        }
      })
    }
  }
}
